import { observable, action, computed } from "mobx";
import { FieldType, ViewModelBase } from "@shoothill/core";

// App
import { ApplicantModel } from "../Models/Domain/ApplicantModel";
import { FormSectionsEnum } from "Globals/Models/FormSectionsEnum";
import PersonalDetailsViewModel from "Globals/ViewModels/FormSections/PersonalDetails/PersonalDetailsViewModel";
import EmploymentDetailsViewModel from "Globals/ViewModels/FormSections/EmploymentDetails/EmploymentDetailsViewModel";
import IncomeDetailsViewModel from "Globals/ViewModels/FormSections/IncomeSavingsAndOutgoings/IncomeDetailsViewModel";
import StatementDetailsViewModel from "./FormSections/StatementDetails/StatementDetailsViewModel";
import PropertyDetailsViewModel from "./FormSections/PropertyDetails/PropertyDetailsViewModel";
import CurrentPropertyDetailsViewModel from "./FormSections/CurrentPropertyDetails/CurrentPropertyDetailsViewModel";
import NewPropertyDetailsViewModel from "./FormSections/NewPropertyDetails/NewPropertyDetailsViewModel";
import BackgroundInformationViewModel from "./FormSections/BackgroundInformation/BackgroundInformationViewModel";
import DeclarationViewModel from "./FormSections/Declarations/DeclarationViewModel";
//import SupportingInformationViewModel from "./FormSections/SupportingInformation/SupportingInformationViewModel";
import ParentCreditReportViewModel from "./FormSections/CreditReport/ParentCreditReportViewModel";
import { ParentSupportingInformationModel } from "Globals/Models/Domain/FormSections/SupportingInformation/ParentSupportingInformationModel";
import ParentSupportingInformationViewModel from "./FormSections/SupportingInformation/ParentSupportingInformationViewModel";
import AmendmentsViewModel from "./Applicant/AmendmentsViewModel";
import { AmendmentsModel } from "Globals/Models/Domain/Admin/applicant/AmendmentsModel";

export default class ApplicantViewModel extends ViewModelBase<ApplicantModel> {
    constructor(applicant: ApplicantModel) {
        super(applicant);
        this.createViewModels();
    }
    // To control moving to the next section - start
    @action
    public updateSectionCompleted = (index: FormSectionsEnum, value: boolean): void => {
        this.localCompleted[index] = value;
    };

    //TODO When adding new section!! Add a false into array below for each section implemented - dont delete this message
    @observable localCompleted = [false, false, false, false, false, false, false, false, false, false, false];

    @observable personalDetailsViewModel = new PersonalDetailsViewModel(this.model.personalDetailsModel, this.updateSectionCompleted);
    @observable employmentDetailsViewModel = new EmploymentDetailsViewModel(this.model.employmentDetailsModel, this.updateSectionCompleted);
    @observable incomeDetailsViewModel = new IncomeDetailsViewModel(this.model.incomeDetailsModel, this.updateSectionCompleted);
    @observable statementDetailsViewModel = new StatementDetailsViewModel(this.model.statementDetailsModel, this.updateSectionCompleted);
    @observable propertyDetailsViewModel = new PropertyDetailsViewModel(this.model.propertyDetailsModel, this.updateSectionCompleted);
    @observable currentPropertyDetailsViewModel = new CurrentPropertyDetailsViewModel(this.model.currentPropertyDetailsModel, this.updateSectionCompleted);
    @observable newPropertyDetailsViewModel = new NewPropertyDetailsViewModel(this.model.newPropertyDetailsModel, this.updateSectionCompleted);
    @observable backgroundInformationViewModel = new BackgroundInformationViewModel(this.model.backgroundInformationModel, this.updateSectionCompleted);
    @observable declarationViewModel = new DeclarationViewModel(this.model.declarationModel, this.updateSectionCompleted);

    @observable parentCreditReportViewModel = new ParentCreditReportViewModel(this.model.parentCreditReportModel, this.updateSectionCompleted);
    @observable parentSupportingInformationViewModel = new ParentSupportingInformationViewModel(this.model.parentSupportingInformationModel, this.updateSectionCompleted);

    @observable amendmentsViewModel = new AmendmentsViewModel(this.model.amendmentsModel);

    @computed
    public get getSectionsCompleted(): boolean[] {
        return this.localCompleted;
    }
    @computed
    public get canSubmit(): boolean {
        return this.localCompleted.every((a) => a === true);
    }
    // To controll moving to the next section - end

    @action
    private createViewModels(): void {
        console.log("CREATE VIEW MODELS()");
        this.model.personalDetailsModel.formId = this.model.formId;
        this.model.personalDetailsModel.applicantId = this.model.id ? this.model.id : "";
        this.personalDetailsViewModel = new PersonalDetailsViewModel(this.model.personalDetailsModel, this.updateSectionCompleted);

        this.model.employmentDetailsModel.formId = this.model.formId;
        this.model.employmentDetailsModel.applicantId = this.model.id ? this.model.id : "";
        this.employmentDetailsViewModel = new EmploymentDetailsViewModel(this.model.employmentDetailsModel, this.updateSectionCompleted);

        this.model.incomeDetailsModel.formId = this.model.formId;
        this.model.incomeDetailsModel.applicantId = this.model.id ? this.model.id : "";
        this.incomeDetailsViewModel = new IncomeDetailsViewModel(this.model.incomeDetailsModel, this.updateSectionCompleted);

        this.model.statementDetailsModel.formId = this.model.formId;
        this.model.statementDetailsModel.applicantId = this.model.id ? this.model.id : "";
        this.statementDetailsViewModel = new StatementDetailsViewModel(this.model.statementDetailsModel, this.updateSectionCompleted);

        this.model.propertyDetailsModel.formId = this.model.formId;
        this.model.propertyDetailsModel.applicantId = this.model.id ? this.model.id : "";
        this.propertyDetailsViewModel = new PropertyDetailsViewModel(this.model.propertyDetailsModel, this.updateSectionCompleted);

        this.model.currentPropertyDetailsModel.formId = this.model.formId;
        this.model.currentPropertyDetailsModel.applicantId = this.model.id ? this.model.id : "";
        this.currentPropertyDetailsViewModel = new CurrentPropertyDetailsViewModel(this.model.currentPropertyDetailsModel, this.updateSectionCompleted);

        this.model.newPropertyDetailsModel.formId = this.model.formId;
        this.model.newPropertyDetailsModel.applicantId = this.model.id ? this.model.id : "";
        this.newPropertyDetailsViewModel = new NewPropertyDetailsViewModel(this.model.newPropertyDetailsModel, this.updateSectionCompleted);

        this.model.backgroundInformationModel.formId = this.model.formId;
        this.model.backgroundInformationModel.applicantId = this.model.id ? this.model.id : "";
        this.backgroundInformationViewModel = new BackgroundInformationViewModel(this.model.backgroundInformationModel, this.updateSectionCompleted);

        this.model.declarationModel.formId = this.model.formId;
        this.model.declarationModel.applicantId = this.model.id ? this.model.id : "";
        this.declarationViewModel = new DeclarationViewModel(this.model.declarationModel, this.updateSectionCompleted);

        this.model.parentCreditReportModel.formId = this.model.formId;
        this.model.parentCreditReportModel.applicantId = this.model.id ? this.model.id : "";
        this.parentCreditReportViewModel = new ParentCreditReportViewModel(this.model.parentCreditReportModel, this.updateSectionCompleted);

        this.model.parentSupportingInformationModel.formId = this.model.formId;
        this.model.parentSupportingInformationModel.applicantId = this.model.id ? this.model.id : "";
        this.parentSupportingInformationViewModel = new ParentSupportingInformationViewModel(this.model.parentSupportingInformationModel, this.updateSectionCompleted);

        this.model.amendmentsModel.formId = this.model.formId;
        this.model.amendmentsModel.applicantId = this.model.id ? this.model.id : "";
        this.amendmentsViewModel = new AmendmentsViewModel(this.model.amendmentsModel);
    }

    public getViewModelByFormSectionEnum(section: FormSectionsEnum) {
        if (section == FormSectionsEnum.PersonalDetails) {
            return this.personalDetailsViewModel;
        }
        if (section == FormSectionsEnum.EmploymentDetails) {
            return this.employmentDetailsViewModel;
        }
        if (section == FormSectionsEnum.IncomeDetails) {
            return this.incomeDetailsViewModel;
        }
        if (section == FormSectionsEnum.StatementDetails) {
            return this.statementDetailsViewModel;
        }
        if (section == FormSectionsEnum.PropertyDetails) {
            return this.propertyDetailsViewModel;
        }
        if (section == FormSectionsEnum.CurrentPropertyDetails) {
            return this.currentPropertyDetailsViewModel;
        }
        if (section == FormSectionsEnum.NewPropertyDetails) {
            return this.newPropertyDetailsViewModel;
        }
        if (section == FormSectionsEnum.BackgroundInformation) {
            return this.backgroundInformationViewModel;
        }
        if (section == FormSectionsEnum.Declaration) {
            return this.declarationViewModel;
        }
        if (section == FormSectionsEnum.CreditReport) {
            return this.parentCreditReportViewModel;
        }
        if (section == FormSectionsEnum.SupportingInformation) {
            return this.parentSupportingInformationViewModel;
        }
    }

    public async isFieldValid(fieldName: keyof FieldType<ApplicantModel>, value: any): Promise<boolean> {
        // let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        // this.setError(fieldName, errorMessage);
        // this.setValid(fieldName, isValid);

        // return isValid;
        return true;
    }
    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
